import IDMGlobals from './../../IDMGlobals';
//
export default class APIRegistration {
  constructor(API) {
    this.api = API;
  }
  async register(regObj, optionalOverrideAppID) {
    const req = await this.api.newBaseRequest('POST', true /*allows appid impersonation*/, false, optionalOverrideAppID);
    req.path = IDMGlobals.APIPath_Registration;
    req.body = {...regObj};
    return await req.exec();
  }
  async enroll(enrollObj) {
    const req = await this.api.newBaseRequest('PUT', true /*allows appid impersonation*/);
    req.path = IDMGlobals.APIPath_Registration;
    req.body = {...enrollObj};
    return await req.exec();
  }
}
